export default __webpack_public_path__ + "static/media/ontraccr-login-img.8c36e316.jpg";